(function () {
  'use strict';

  var sizeToastTimer;
  function showSizeToast() {
    var toast = document.getElementById('s-isl');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 's-isl';
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-atomic', 'true');
      toast.textContent = 'Please select a size';
      document.body.appendChild(toast);
    }
    toast.style.maxWidth = 'calc(100vw - 32px)';
    toast.style.whiteSpace = 'normal';
    toast.style.boxSizing = 'border-box';
    clearTimeout(sizeToastTimer);
    toast.classList.add('s');
    sizeToastTimer = setTimeout(function () { toast.classList.remove('s'); }, 4000);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('input[type="radio"]') || input.name.toLowerCase() !== 'size') return;
    var toast = document.getElementById('s-isl');
    if (toast) toast.classList.remove('s');
    clearTimeout(sizeToastTimer);
    var errorBox = input.form && input.form.querySelector('[data-innxo-checkout-error]');
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
  });



  var activeModal = null;
  var activeState = null;
  var lastTrigger = null;

  /* INNXO CHECKOUT NAVIGATION V3 */
  function isThemeEditorPreview() {
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var embedded = false;
    try { embedded = window.self !== window.top; } catch (e) { embedded = true; }
    return designMode || embedded;
  }

  function checkoutUrl() {
    return window.location.origin + '/checkout';
  }

  function openCheckoutTargetFromGesture() {
    return null;
  }

  function goToCheckout() {
    window.location.assign(checkoutUrl());
  }

  function closeCheckoutTarget(target) {
    if (!target) return;
    try {
      if (!target.closed) target.close();
    } catch (e) {}
  }


  function money(amount, currency) {
    var value = Number(amount || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: currency || 'INR',
        minimumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return '₹' + value.toFixed(2);
    }
  }

  function formVariantId(form) {
    var field = form && form.querySelector('[name="id"]');
    return field ? String(field.value || '') : '';
  }

  function formQuantity(form) {
    var field = form && form.querySelector('[name="quantity"]');
    var qty = field ? parseInt(field.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function readVariants(modal) {
    var node = modal.querySelector('[data-innxo-current-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (e) { return []; }
  }

  function currentVariant(modal, id) {
    var variants = readVariants(modal);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return variants[0] || null;
  }

  function addonData(modal) {
    var toggle = modal.querySelector('[data-innxo-addon-toggle]');
    var field = modal.querySelector('[data-innxo-addon-variant]');
    if (!toggle || !field) return { enabled: false, id: '', price: 0 };
    var option = field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
    var price = Number(option && option.dataset ? option.dataset.price : field.dataset.price || 0);
    return { enabled: !!toggle.checked, id: String(field.value || ''), price: price || 0 };
  }

  function updateModal(modal) {
    if (!activeState || activeState.modal !== modal) return;
    var variant = currentVariant(modal, activeState.variantId);
    if (!variant) return;

    var qty = activeState.quantity;
    var title = modal.querySelector('[data-innxo-current-title]');
    var variantLine = modal.querySelector('[data-innxo-current-variant]');
    var price = modal.querySelector('[data-innxo-current-price]');
    var image = modal.querySelector('[data-innxo-current-image]');
    var addon = addonData(modal);
    var addonCard = modal.querySelector('[data-innxo-addon-card]');
    var addonPrice = modal.querySelector('[data-innxo-addon-price]');
    var total = modal.querySelector('[data-innxo-total-price]');
    var totalNote = modal.querySelector('[data-innxo-total-note]');

    if (title) title.textContent = modal.dataset.currentTitle || '';
    var variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title + ' · ' : '';
    if (variantLine) variantLine.textContent = variantTitle + 'Qty ' + qty;
    if (price) price.textContent = money(Number(variant.price || 0) * qty, modal.dataset.currency);

    if (image) {
      var featured = variant.featured_image || variant.featured_media;
      var src = '';
      if (featured) src = featured.src || featured.url || (featured.preview_image && featured.preview_image.src) || '';
      image.src = src || modal.dataset.currentImage || image.src;
    }

    if (addonCard) addonCard.classList.toggle('is-selected', addon.enabled);
    if (addonPrice) addonPrice.textContent = money(addon.price, modal.dataset.currency);

    var totalAmount = Number(variant.price || 0) * qty + (addon.enabled ? addon.price : 0);
    if (total) total.textContent = money(totalAmount, modal.dataset.currency);
    if (totalNote) totalNote.textContent = addon.enabled ? 'Current product + add-on' : 'Current product';
  }

  function modalError(modal, message) {
    var box = modal.querySelector('[data-innxo-modal-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function openModal(trigger) {
    var form = trigger.closest('form');
    if (!form) return;
    var variantId = formVariantId(form);
    if (!variantId) return;

    var modal = document.querySelector('[data-innxo-buy-modal]');
    if (!modal) {
      directCheckout(form);
      return;
    }

    var variant = currentVariant(modal, variantId);
    if (variant && variant.available === false) {
      modalError(modal, 'This option is currently unavailable. Please choose another option.');
      return;
    }

    activeModal = modal;
    activeState = {
      modal: modal,
      form: form,
      variantId: variantId,
      quantity: formQuantity(form)
    };
    lastTrigger = trigger;
    modalError(modal, '');
    updateModal(modal);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('prevent-scroll');
    var close = modal.querySelector('[data-innxo-modal-close]');
    if (close && close.focus) close.focus();
  }

  function closeModal() {
    if (!activeModal) return;
    activeModal.classList.remove('is-open');
    activeModal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('prevent-scroll');
    activeModal = null;
    activeState = null;
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function collectProperties(form) {
    var properties = {};
    if (!form) return properties;
    var data = new FormData(form);
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') properties[match[1]] = value;
    });
    return properties;
  }

  function currentLineItem(form, variantId, qty) {
    var item = { id: Number(variantId), quantity: qty };
    var properties = collectProperties(form);
    if (Object.keys(properties).length) item.properties = properties;
    var sellingPlan = form && form.querySelector('[name="selling_plan"]');
    if (sellingPlan && sellingPlan.value) item.selling_plan = Number(sellingPlan.value);
    return item;
  }

  function cartAdd(items) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'Could not add the selected items.');
        });
      }
      return response.json();
    });
  }

  function directCheckout(form) {
    var variantId = formVariantId(form);
    if (!variantId) return;
    var button = form.querySelector('[data-innxo-buy-now]');
    var checkoutTarget = openCheckoutTargetFromGesture();
    if (button) button.disabled = true;

    cartAdd([currentLineItem(form, variantId, formQuantity(form))])
      .then(function () {
        goToCheckout(checkoutTarget);
      })
      .catch(function () {
        closeCheckoutTarget(checkoutTarget);
        if (button) button.disabled = false;
      });
  }

  function continueCheckout(modal) {
    if (!activeState || activeState.modal !== modal) return;
    var button = modal.querySelector('[data-innxo-continue]');
    var variant = currentVariant(modal, activeState.variantId);
    if (!variant) return;

    var items = [currentLineItem(activeState.form, activeState.variantId, activeState.quantity)];
    var addon = addonData(modal);
    if (addon.enabled && addon.id) items.push({ id: Number(addon.id), quantity: 1 });

    var checkoutTarget = openCheckoutTargetFromGesture();

    if (button) {
      button.disabled = true;
      var label = button.querySelector('span');
      if (label) label.textContent = 'Preparing checkout…';
    }
    modalError(modal, '');

    cartAdd(items)
      .then(function () {
        goToCheckout(checkoutTarget);
      })
      .catch(function (error) {
        closeCheckoutTarget(checkoutTarget);
        modalError(modal, error.message || 'Could not prepare checkout. Please try again.');
        if (button) {
          button.disabled = false;
          var label = button.querySelector('span');
          if (label) label.textContent = 'Continue to Checkout';
        }
      });
  }

  function initializeRecommendation(root) {
    if (!root || root.dataset.innxoReady === 'true') return;
    root.dataset.innxoReady = 'true';
    var candidates = Array.prototype.slice.call(root.querySelectorAll('[data-innxo-rec-candidate]'));
    if (!candidates.length) {
      root.hidden = true;
      return;
    }
    for (var i = 0; i < candidates.length; i++) candidates[i].hidden = true;
    var chosen = candidates[Math.floor(Math.random() * candidates.length)];
    chosen.hidden = false;
  }

  function initializeRecommendations(scope) {
    var roots = (scope || document).querySelectorAll ? (scope || document).querySelectorAll('[data-innxo-cart-rec]') : [];
    for (var i = 0; i < roots.length; i++) initializeRecommendation(roots[i]);
  }

  document.addEventListener('click', function (event) {
    var buyNow = event.target.closest('[data-innxo-buy-now]');
    if (buyNow) {
      event.preventDefault();
      event.stopPropagation();
      openModal(buyNow);
      return;
    }

    var close = event.target.closest('[data-innxo-modal-close]');
    if (close) {
      event.preventDefault();
      closeModal();
      return;
    }

    var cont = event.target.closest('[data-innxo-continue]');
    if (cont) {
      event.preventDefault();
      var modal = cont.closest('[data-innxo-buy-modal]');
      if (modal) continueCheckout(modal);
      return;
    }

    var add = event.target.closest('[data-innxo-rec-add]');
    if (add) {
      event.preventDefault();
      var card = add.closest('[data-innxo-rec-candidate]');
      if (!card) return;
      var variantField = card.querySelector('[data-innxo-rec-variant]');
      if (!variantField || !variantField.value) return;
      var original = add.textContent;
      add.disabled = true;
      add.textContent = 'Adding…';
      cartAdd([{ id: Number(variantField.value), quantity: 1 }])
        .then(function () {
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
            drawer.onCartDrawerUpdate();
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          add.disabled = false;
          add.textContent = 'Try again';
          setTimeout(function () { add.textContent = original; }, 1600);
        });
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-innxo-addon-toggle]')) {
      var modal = event.target.closest('[data-innxo-buy-modal]');
      if (modal) updateModal(modal);
    }
    if (event.target.matches('[data-innxo-addon-variant]')) {
      var addonModal = event.target.closest('[data-innxo-buy-modal]');
      if (addonModal) updateModal(addonModal);
    }
    if (event.target.matches('[data-innxo-rec-variant]')) {
      var card = event.target.closest('[data-innxo-rec-candidate]');
      var price = card && card.querySelector('[data-innxo-rec-price]');
      var option = event.target.options && event.target.options[event.target.selectedIndex];
      if (price && option && option.dataset.priceText) price.textContent = option.dataset.priceText;
    }
  });

  // Cart checkout uses Shopify's native POST form; do not intercept it.

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeModal) closeModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeRecommendations(document); });
  } else {
    initializeRecommendations(document);
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initializeRecommendations(document);
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();